import { AnyAction } from "redux";

import * as types from "./types";

import { initialState } from ".";

export default function planningAndSchedulingReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case types.OPEN_MODAL:
      return {
        ...state,
        isFeedStockFeedbackFormModalOpen: action.payload.isFeedStockFeedbackFormModalOpen,
      };
    case types.CLOSE_MODAL:
      return {
        ...state,
        isFeedStockFeedbackFormModalOpen: action.payload.isFeedStockFeedbackFormModalOpen,
      };
    case types.SET_FEEDSTOCK_TRADING_FEEDBACK_DATA:
      return {
        ...state,
        planningEvaluationData: {
          ...state.feedStockTradingFeedbackFormData,
          [action.payload.field]: action.payload.value,
        },
      };
    case types.CLEAR_FEEDSTOCK_TRADING_FEEDBACK_DATA:
      return {
        ...state,
        planningEvaluationData: initialState.feedStockTradingFeedbackFormData,
      };
    case types.OPEN_FEEDSTOCK_TRADING_TABLE_MODAL: {
      return {
        ...state,
        isFeedstockTradingTableModalOpen:
          action.payload.isFeedstockTradingTableModalOpen,
      };
    }
    case types.CLOSE_FEEDSTOCK_TRADING_TABLE_MODAL: {
      return {
        ...state,
        isFeedstockTradingTableModalOpen:
          action.payload.isFeedstockTradingTableModalOpen,
        areFeedbackDetailsShown: action.payload.areFeedbackDetailsShown,
      };
    }
    case types.SHOW_FEEDSTOCK_TRADING_FEEDBACK_DETAILS: {
      return {
        ...state,
        areFeedbackDetailsShown: action.payload.areFeedbackDetailsShown,
        selectedFeedback: action.payload.selectedFeedback,
      };
    }
    case types.HIDE_FEEDSTOCK_TRADING_FEEDBACK_DETAILS: {
      return {
        ...state,
        areFeedbackDetailsShown: action.payload.areFeedbackDetailsShown,
        selectedFeedback: null,
      };
    }
    case types.SUBMIT_FEEDSTOCK_TRADING_FEEDBACK: {
      return {
        ...state,
        isSubmitting: true,
        hasSubmissionError: false,
        planningEvaluationData: {
          ...action.payload.planningEvaluationData,
        },
      };
    }
    case types.SUBMIT_FEEDSTOCK_TRADING_FEEDBACK_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        hasSubmissionError: false,
        submissionSuccess: true,
      };
    }
    case types.SUBMIT_FEEDSTOCK_TRADING_FEEDBACK_ERROR: {
      return {
        ...state,
        isSubmitting: false,
        submissionSuccess: false,
        hasSubmissionError: true,
      };
    }
    case types.RESET_FEEDSTOCK_TRADING_FEEDBACK_SUBMISISON: {
      return {
        ...state,
        submissionSuccess: action.payload.submissionSuccess,
      };
    }
    default:
      return state;
  }
}
